export const SearchCategories = ({ options, setCategory }) => {
    if (options.length === 0) return null;

    const getCategories = () => {
        return options.map((category) => (
            <option key={category.value} value={category.value}>
                {category.label}
            </option>
        ))
    }

    const handleCategorySelected = (e) => {
        setCategory(e.target.value);
    }

    return (
        <>
            <label htmlFor='search-cat' className="text-flyers-mid-gray text-sm font-heading uppercase tracking-wider hidden sm:block">Category</label>
            <select
                name='search-cat'
                id='search-cat'
                onChange={handleCategorySelected}
                className="px-4 py-2 rounded bg-flyers-black text-white border border-flyers-dark-gray focus:ring-2 focus:ring-flyers-orange outline-none w-full sm:w-auto"
            >
                <option>Select...</option>
                {getCategories()}
            </select>
        </>
    )
}
